import React, { useEffect, useState } from "react";
import { fetchMeetupspagelist } from "../services/Meetupspagelist";
import { API_BASE } from "../api/apiConfig";

const Meetupspagecitydata = () => {
  const [meetups, setMeetups] = useState([]);
  const [filteredMeetups, setFilteredMeetups] = useState([]);

  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const [city, setCity] = useState("All");
  const [viewMode, setViewMode] = useState("all"); // all | city
  const [loading, setLoading] = useState(true);
  const cities = ["All", ...new Set(meetups.map(item => item.city))];


  /* ================= API LOAD ================= */
  useEffect(() => {
    loadMeetups();
  }, []);

  const loadMeetups = async () => {
    try {
      const res = await fetchMeetupspagelist();
      if (res?.status) {
        setMeetups(res.data);
        setFilteredMeetups(res.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= FILTER LOGIC ================= */
  useEffect(() => {
    let data = [...meetups];

    if (search) {
      data = data.filter(
        (item) =>
          item.heading.toLowerCase().includes(search.toLowerCase()) ||
          item.city.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (category !== "All") {
      data = data.filter((item) =>
        JSON.parse(item.category).includes(category)
      );
    }

    if (city !== "All") {
      data = data.filter((item) => item.city === city);
    }

    setFilteredMeetups(data);
  }, [search, category, city, meetups]);

  if (loading) {
    return <p className="text-center py-10">Loading meetups...</p>;
  }

  /* ================= GROUP BY CITY ================= */
  const groupedByCity = filteredMeetups.reduce((acc, item) => {
    acc[item.city] = acc[item.city] || [];
    acc[item.city].push(item);
    return acc;
  }, {});

  return (

     <>

     <div className="sticky top-0 z-10 bg-white border-b border-slate-200 px-4 py-3">
        <div className="relative">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-search absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400"
          >
            <circle cx={11} cy={11} r={8} />
            <path d="m21 21-4.3-4.3" />
          </svg>
          <input
            placeholder="Search meetups..."
            className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
            type="text" value={search} onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>
      
      <div className="px-4 py-4 border-b border-slate-100">
        <div className="flex gap-2 pb-2 custom-scroll">
          {cities.map((c) => (
            <button
              key={c}
              onClick={() => setCity(c)}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all
                ${
                  city === c
                    ? "bg-teal-500 text-white shadow-md"
                    : "bg-white text-slate-700 border border-slate-200 hover:border-teal-500"
                }`}
            >
              {c === "All" ? "All Cities" : c}
            </button>
          ))}
        </div>
      </div>

      
      <div className="px-4 py-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-base font-bold text-slate-800">
            Upcoming Meetups
          </h2>
          <span className="text-xs text-slate-600">{filteredMeetups.length} meetups</span>
        </div>
        <div className="space-y-4">

        {filteredMeetups.map((item) => (
            <a className="block" href={`/MeetupsDtl/${item.id}`}>
              <div className="rounded-lg border bg-card text-card-foreground shadow-sm overflow-hidden hover:shadow-md transition-shadow">
                <div className="relative h-40 w-full">
                  <img
                    alt={item.city}
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0
                    }}
                    src={`${API_BASE}/${item.image}`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                  {/*<div className="inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent text-primary-foreground hover:bg-primary/80 absolute top-2 right-2 text-xs px-2 py-1 bg-teal-500 border-none">
                    Adventure
                  </div>*/}
                  <div className="absolute bottom-3 left-3 right-3">
                    <h3 className="font-semibold text-base text-white mb-1 line-clamp-1">
                       {item.heading}
                    </h3>
                  </div>
                </div>
                <div className="p-3 space-y-2">
                  <div className="flex items-center gap-2 text-sm text-slate-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-4 w-4 text-teal-600 flex-shrink-0"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span className="font-medium"> {item.city}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-slate-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-4 w-4 text-teal-600 flex-shrink-0"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span>{item.date}</span>
                  </div>
                  <div className="flex items-center justify-between pt-1">
                    {/*<div className="flex items-center gap-2 text-sm text-slate-600">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-users h-4 w-4 text-teal-600 flex-shrink-0"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx={9} cy={7} r={4} />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                      <span>24 attending</span>
                    </div>*/}
                    <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 rounded-md bg-teal-500 hover:bg-teal-600 text-white h-8 px-3 text-xs">
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            </a>
        ))}


        </div>
      </div>

    </>

  );
};

export default Meetupspagecitydata;
